import { IFirestoreImageLinkRepository } from "../../../cloudServices/googleFirebaseServices/database/firestore/FirestoreImageLinkRepository";
import { FirestoreDataRepositoryFactory } from "../../../cloudServices/googleFirebaseServices/database/firestore/FirestoreDataRepositoryFactory";
import { enumFirestoreDataRepositoryDataType } from "../../../cloudServices/googleFirebaseServices/database/firestore/enums";
import { IFirestoreBaseRepository } from "../../../cloudServices/googleFirebaseServices/database/firestore/FirestoreBaseRepository";
import { IImageLink, IImageLinkAsJson } from "../../../../dataObjects/models/digitalMedia/ImageLink";
import { enumImageLinkType } from "../../../../dataObjects/enums";
import { deleteCloudStorageFilesForBaseStoragePath } from "../../../cloudStorageServices/cloudStorageFileDeleteActions";


export function expungeImageLink(imageLink: IImageLink): Promise<void> {
  return new Promise<void>(async (resolve, reject) => {
    try {
      // get a ImageLink repository from the repository factory
      const firestoreImageLinkRepository: IFirestoreImageLinkRepository =
        FirestoreDataRepositoryFactory.CreateDataRepository(enumFirestoreDataRepositoryDataType.ImageLink) as
        IFirestoreBaseRepository<IImageLink, IImageLinkAsJson>;

      // call the repository expunge() method to delete the object
      await firestoreImageLinkRepository.expunge(imageLink.id);

      // FOR EXPUNGE ONLY: Also delete any image files in cloud storage
      if (imageLink.imageLinkType === enumImageLinkType.GoogleCloudStorage) {
        deleteCloudStorageFilesForBaseStoragePath(imageLink.baseStoragePath);
      }

      resolve();
    } catch (error: any) {
      reject(error);
    }
  });
}